/**
 * Fereastra cu exemple de lucrari.
 *
 * Fiecare `<dialog class="almam-ex">` isi declara singur adresa care il deschide
 * (`data-trigger`, de obicei `#exemple`). Legatura se face pe DOCUMENT, nu pe
 * fiecare buton in parte: butonul care o deschide sta in alta sectiune, iar in
 * editorul de teme sectiunile se re-randeaza independent, deci un ascultator pus
 * pe buton ar disparea la prima modificare a bannerului.
 */
(function () {
  'use strict';

  var CLASA_BLOCARE = 'almam-ex-open';

  function panouri() {
    return Array.prototype.slice.call(document.querySelectorAll('dialog.almam-ex'));
  }

  /**
   * Deblocarea paginii se leaga de ATRIBUTUL `open`, nu de evenimentul `close`.
   *
   * Masurat pe magazin (2026-09-01): pe paginile temei evenimentul `close` al lui
   * `<dialog>` nu se declanseaza deloc - nici pe dialogul sectiunii, nici pe un
   * `<dialog>` creat pe loc in consola, desi `close()` e nativ si nepatchuit.
   * Fereastra se inchidea corect, dar `almam-ex-open` ramanea pe `<html>` si
   * pagina nu se mai putea derula. Un observator de atribut nu depinde de
   * evenimente, deci prinde si Esc, si apasarea pe fundal, si `close()` din cod.
   */
  function urmareste(dialog) {
    if (dialog.almamObservat) return;
    var observator = new MutationObserver(function () {
      if (!dialog.open) document.documentElement.classList.remove(CLASA_BLOCARE);
    });
    observator.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.almamObservat = true;
  }

  function deschide(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal !== 'function') return;
    urmareste(dialog);
    dialog.showModal();
    // `<dialog>` opreste apasarile pe fundal, dar nu si derularea paginii de sub
    // el: pe telefon degetul ar misca pagina din spate in loc de lista.
    document.documentElement.classList.add(CLASA_BLOCARE);
  }

  function inchide(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    var declansator = event.target.closest ? event.target.closest('a[href], button[data-almam-ex-open]') : null;
    if (!declansator) return;

    var tinta = declansator.getAttribute('href') || declansator.getAttribute('data-almam-ex-open');
    if (!tinta) return;

    var dialog = panouri().filter(function (d) {
      return d.getAttribute('data-trigger') === tinta;
    })[0];
    if (!dialog) return;

    event.preventDefault();
    deschide(dialog);
  });

  document.addEventListener('click', function (event) {
    var buton = event.target.closest ? event.target.closest('[data-almam-ex-close]') : null;
    if (buton) {
      inchide(buton.closest('dialog.almam-ex'));
      return;
    }

    // Apasarea pe fundal ajunge chiar pe `<dialog>`, fiindca panoul dinauntru
    // acopera exact suprafata ferestrei.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('almam-ex')) {
      inchide(event.target);
    }
  });

  /**
   * In editorul de teme fereastra ar fi invizibila: e inchisa, iar Anastasia
   * n-ar avea cum sa vada ce editeaza. La selectarea sectiunii sau a unui bloc
   * se deschide singura, iar la deselectare se inchide.
   */
  document.addEventListener('shopify:section:select', function (event) {
    deschide(event.target.querySelector('dialog.almam-ex'));
  });

  document.addEventListener('shopify:block:select', function (event) {
    var dialog = event.target.closest ? event.target.closest('dialog.almam-ex') : null;
    deschide(dialog);
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    inchide(event.target.querySelector('dialog.almam-ex'));
  });
})();
